import { Component, OnInit, ElementRef, ViewEncapsulation, forwardRef, ChangeDetectorRef, Renderer, Injector } from '@angular/core';
import { BaseAbstractControl, ModalService } from 'moh-package';
import { FormGroup, FormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { SrvSurvivors } from '../../../models/Survivors/SrvSurvivors';
import { SurvivorsService } from '../../../services/survivors/survivors.service';

@Component({
  selector: 'moh-survivors-wizard',
  templateUrl: './survivors-wizard.component.html',
  styleUrls: ['./survivors-wizard.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SurvivorsWizardComponent), multi: true, },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => SurvivorsWizardComponent) }]
})
export class SurvivorsWizardComponent extends BaseAbstractControl implements OnInit {

  surviorsObj: SrvSurvivors;

  constructor(injector: Injector, private changeDetector: ChangeDetectorRef, private survivorsService: SurvivorsService, private modal: ModalService) {

    super(injector);
  }

  ngOnInit() {

    this.initializeFormGroup();

    super.ngOnInit();
  }

  ngAfterContentInit() {
    this.changeDetector.detectChanges();
  }

  initializeFormGroup() {

    this.baseAbstractControl = new FormGroup({
      ClaimerDetails: new FormControl(),
      RepresenterDetails: new FormControl(),
      ClaimDetails: new FormControl(),
      AdditionalInfo: new FormControl(),
      Declaration: new FormControl()
    });
  }

  sendSurvivorsForm() {

    var duplicateObject = JSON.parse(JSON.stringify(this.baseAbstractControl.value));

    this.surviorsObj = new SrvSurvivors(duplicateObject);

    this.survivorsService.SendSurvivorsRequest(this.surviorsObj).subscribe(

      (res) => {
        this.handleResponse(res);
      },
      (error) => {
        this.modal.errorMsg('', 'אירעה שגיאה', 'אישור');
        console.log(error)
      });
  }

  private handleResponse(response) {

    this.modal.successMsg('', 'טופס נשלח בהצלחה', 'אישור');
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/survivors/survivors-wizard/survivors-wizard.component.ts